export const siteSettings = {
  name: "Forward Markets",
  link: "https://forwardmarkets.net/",
  email: "support@forwardmarkets.net/",
  appLink: "https://app.forwardmarkets.net/",
};
